<div class="tabview-innerButtons" *permission="Permission['Gestion.Comercial.Reportes.Ventas.SeleccionGerenteTienda']">
  <div class="items">
    <div class="item">
      <button pButton pRipple label="Reporte gerente" class="p-button-secondary p-button-raised p-button-rounded min-pad" (click)="loadData()"></button>
    </div>
    <div class="item">
      <button pButton pRipple label="Reporte tienda" class="p-button-secondary p-button-raised p-button-rounded min-pad" (click)="onSelectStore(storeID)"></button>
    </div>
  </div>
</div>

<div class="tabview-innerFilter" *permission="Permission['Gestion.Comercial.Reportes.SeleccionTienda']">
  <div class="form__group">
    <div class="p-float-label">
      <p-dropdown (onChange)="onchangeStore(selectedStore)" [options]="listStore" [(ngModel)]="selectedStore" [editable]="false" optionLabel="name" optionValue="id"></p-dropdown>
      <label>Tienda</label>
    </div>
  </div>
</div>

<div class="tabview-charts">
  <div class="chart__content" *ngIf="listSalesBrands.length > 0">
    <p-chart type="bar" [data]="basicDataSales" [options]="basicOptionsSales"></p-chart>
  </div>
  <div class="chart__content" *ngIf="listPriceRange.length > 0">
    <p-chart type="bar" [data]="basicDataPriceRange" [options]="basicOptionsPriceRange"></p-chart>
  </div>
</div>

